import mod from "-!./Contract.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Contract.js?vue&type=script&lang=js&"